import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "dividend-report p-2 m-2" }
const _hoisted_2 = { class: "filter-btn-group" }
const _hoisted_3 = { class: "radio-filter" }
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = { class: "grid-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "select",
            id: "dividend-report-individual",
            class: "option-input-1",
            value: "false",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.cumulative) = $event))
          }, null, 512), [
            [_vModelRadio, $data.cumulative]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "select",
            id: "dividend-report-cumulative",
            class: "option-input-2",
            value: "true",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.cumulative) = $event))
          }, null, 512), [
            [_vModelRadio, $data.cumulative]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("label", {
            for: "dividend-report-individual",
            class: "option option-1"
          }, [
            _createElementVNode("div", { class: "dot" }),
            _createElementVNode("span", null, "Individual")
          ], -1)),
          _cache[3] || (_cache[3] = _createElementVNode("label", {
            for: "dividend-report-cumulative",
            class: "option option-2"
          }, [
            _createElementVNode("div", { class: "dot" }),
            _createElementVNode("span", null, "Cumulative")
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_card, {
        flat: "",
        rounded: "lg",
        class: "dividend-report-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_data_table, {
            headers: $data.headers,
            items: $data.cumulativeDividends,
            "items-per-page": 5,
            "items-per-page-options": [10, 15, 20, 30, 50, 100, 200],
            "item-value": "dividend_id",
            class: "custom-data-table"
          }, {
            [`item.platform_name`]: _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString($options.getPlatformNames(item.platform_id)), 1)
            ]),
            [`item.amount`]: _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatPrice(item.amount)), 1)
            ]),
            [`item.created_at`]: _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatDate(item.created_at, true)), 1)
            ]),
            _: 2
          }, 1032, ["headers", "items"])
        ]),
        _: 1
      })
    ])
  ]))
}